// Shared helper for calling the Cloud-Run proxy from the dashboard.
//
// Usage:
//   const data = await proxyFetch(
//       'proxy/download-generator/generate-link', // endpoint after “…/proxy/”
//       firebaseIdToken,                          // user token (string)
//       'GET',                                    // HTTP method (default GET)
//       'target=https://…',                       // optional query-string
//       { 'X-Product-Name': 'SOME_DOC_ID' }       // optional extra headers
//   );

export const getProxyBaseUrl = () => {
    const buildType = process.env.REACT_APP_BUILD_TYPE;
    return buildType === 'production'
      ? process.env.REACT_APP_PROXY_URL_PRODUCTION
      : process.env.REACT_APP_PROXY_URL_STAGING;
  };
  
  export const proxyFetch = async (
    endpoint,
    token,
    method = 'GET',
    queryString = '',
    extraHeaders = {},
    body = undefined
  ) => {
    if (!token) throw new Error('Missing Firebase ID token');
  
    const base   = getProxyBaseUrl();
    const qs     = queryString ? (endpoint.includes('?') ? '&' : '?') + queryString : '';
    const url    = `${base}/${endpoint}${qs}`;
  
    const res = await fetch(url, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...extraHeaders,
      },
      ...(body ? { body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', ...extraHeaders, Authorization: `Bearer ${token}` } } : {}),
    });
  
    // Attempt to parse JSON, but fall back to text if necessary
    const mime = res.headers.get('content-type') || '';
    const data = mime.includes('application/json') ? await res.json() : await res.text();
  
    if (!res.ok) {
      const msg = typeof data === 'string' ? data : data?.error || 'Proxy request failed';
      throw new Error(msg);
    }
  
    return data;
  };
  